/**
 * Het gesprek nog eens nalezen onder het argumentenformulier, zodat de
 * leerlingen er een stuk uit kunnen selecteren voor "Leg uit wat er staat"
 * of "Zeg het korter".
 */
import React from 'react';
import { kleur } from '../../../theme/tokens';
import { basis } from '../stijlen';
import { hulpStijlen } from './HulpVanSocrates';

export function GesprekMeelezen({ berichten }) {
  return (
    <div style={styles.gesprekBlok}>
      <h3 style={styles.hulpKop}>Het gesprek</h3>
      <p style={styles.uitleg}>
        Selecteer hier een stukje tekst en gebruik dan “Leg uit wat er staat”
        of “Zeg het korter”.
      </p>
      <div style={styles.gesprekLog}>
        {berichten.length === 0 ? (
          <p style={styles.hulpTekst}>Er is nog geen gesprek.</p>
        ) : berichten.map((msg, idx) => (
          <div key={idx} style={styles.gesprekRegel}>
            <span style={styles.gesprekVan}>{msg.type === 'user' ? 'Jullie' : msg.from}</span>
            <span>{msg.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  ...basis,
  ...hulpStijlen,
  gesprekBlok: { marginTop: '20px' },
  gesprekLog: { maxHeight: '260px', overflowY: 'auto', background: 'white', border: `1px solid ${kleur.lijn}`, borderRadius: '12px', padding: '12px 14px', display: 'flex', flexDirection: 'column', gap: '10px' },
  gesprekRegel: { fontSize: '14px', lineHeight: 1.5 },
};
